import React from 'react'
import CommonSectionTitle from '../../../App/Components/CommonSectionTitle'
import RightContentMap from '../../components/RightContentMap'
import _ from 'lodash'

const LdArrays = () => {
    const dataArray = [
        "Kuwait",
        "Panama",
        "Niger",
        "Colombia",
        "Mali",
        "Sint Maarten",
        "Malaysia",
        "Taiwan",
        "Italy",
        "Indonesia",
    ];

    const dataArray2 = [
        "Kuwait",
        "Panama",
        "Niger",
        "Colombia",
        "Mali",
        false,
        '',
        "",
        undefined,
        null,
        "Sint Maarten",
        "Malaysia",
        "Taiwan",
        "Italy",
        "Indonesia",
    ];

    let chunckedArray = _.chunk(dataArray, 5);
    return (
        <div className='md:flex text-gray-800 dark:text-cDarkText'>
            <div className='px-1 pb-10'>
                <RightContentMap />
            </div>

            <div className='md:w-[70%] bg-gray-100 dark:bg-cDarkBG2 rounded-lg shadow-lg p-5'>
                <CommonSectionTitle
                    title='Lodash: Array methods'
                    withBackLink={true}
                    backLinkUrl='/play'
                />
                <div className="pt-5">
                    Getting started with Lodash-array methods with some advanced features. [practice, blog, info]
                </div>

                <div className='my-5'>
                    <h2 className="text-lg font-bold mb-4">Lodash: Array methods</h2>
                    <p>Let's take an array of 10 items for this section and do some operations with it</p>
                    <p>The array 'dataArray' of size 10 is as follows:</p>
                    <div className="pb-4"></div>

                    <code className="bg-gray-300 dark:bg-cDarkMainBG px-1 py-2 rounded-0">
                        {dataArray.toString()}
                    </code>

                    <div className="mt-7"><hr /></div>

                    <div className="pt-5">
                        <div className="text-lg font-semibold pb-4">_.chunk : 'dataArray' Chunked the size 10 dataArray into size 5 of 2 new arrays in a 2D array of 'chunckedArray'</div>
                        <code className="bg-gray-300 dark:bg-cDarkMainBG px-1 py-2 rounded-0">
                            let chunckedArray = _.chunk(dataArray, 5);
                        </code>
                        <div className="py-3">Output:</div>
                        <code className="bg-gray-300 dark:bg-cDarkMainBG px-1 py-2 rounded-0">
                            {chunckedArray[0].toString()}
                        </code>
                        <div className="py-2.5"></div>
                        <code className="bg-gray-300 dark:bg-cDarkMainBG px-1 py-2 rounded-0">
                            {chunckedArray[1].toString()}
                        </code>
                    </div>

                    <div className="mt-7"><hr /></div>
                    <div className="pt-5">
                        <div className="text-lg font-semibold pb-4">_.compact : 'dataArray2' check and remove all nullable values i.e. null, "", '', false, undefined etc.</div>
                        <div className="py-3">dataArray2:</div>
                        <code className="bg-gray-300 dark:bg-cDarkMainBG px-1 py-2 rounded-0">
                            {dataArray2.toString()}
                        </code>
                        <div className="pt-5"></div>
                        <code className="bg-gray-300 dark:bg-cDarkMainBG px-1 py-2 rounded-0">
                            let chunckedArray = _.chunk(dataArray, 5);
                        </code>
                        <div className="py-3">Output: _.compact(dataArray2)</div>
                        <code className="bg-gray-300 dark:bg-cDarkMainBG px-1 py-2 rounded-0">
                            {_.compact(dataArray2).toString()}
                        </code>

                    </div>

                </div>
            </div>
        </div>
    )
}

export default LdArrays